// https://www.notion.so/ikala/RC-a01837958c064082a58ac5941a268291
export const MAX_STEPS = 10000
